var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 30,
    viewBox: "0 0 109 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70838 0.529297V23.3628H18.6746V29.0712H0V0.529297H5.70838Z",
    fill: "#12121D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4893 0.529297V6.23768H27.7678V11.9461H40.4893V17.6544H27.7678V23.3628H40.4893V29.0712H22.0594V0.529297H40.4893Z",
    fill: "#12121D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1896 29.0712L42.6934 0.529297H49.0134L58.7176 21.0387L68.3811 0.529297H74.7011L61.2048 29.0712H56.1896Z",
    fill: "#12121D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3942 0.529297V23.3628H96.3604V29.0712H77.6859V0.529297H83.3942Z",
    fill: "#12121D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.92,
    y: 23.2461,
    width: 5.82488,
    height: 5.82488,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61b8bd104b59a9b497a4199ce28a380a.svg";
export { ForwardRef as ReactComponent };